<template lang="pug">
swiper(ref='swiperRef', :options='swiperOptions', @click.native='slideClicked')
  swiper-slide
    #video
      retina-image.video-thumnail(name='btn-intro-movie')
  swiper-slide
    #lesson-flow
      retina-image.lesson-flow-img(name='btn-lesson-flow')
  swiper-slide
    #faq
      retina-image.faq-img(name='btn-faq')
  .swiper-pagination(slot='pagination')
</template>

<script>
export default {
  data() {
    return {
      swiperOptions: {
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
        },
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        loop: true,
      },
    }
  },
  computed: {
    swiper() {
      return this.$refs.swiperRef.swiper
    },
  },
  methods: {
    slideClicked(event) {
      if (event.target.classList.contains('video-thumnail')) {
        this.$emit('didTapIntroMovie')
      }

      if (event.target.classList.contains('lesson-flow-img')) {
        this.$emit('didTapLessonFlow')
      }

      if (event.target.classList.contains('faq-img')) {
        this.$emit('didTapFAQ')
      }
    },
  },
}
</script>

<style lang="scss">
#lesson-flow,
#video,
#faq {
  width: 100%;
  height: auto;
  text-align: center;

  img {
    width: 100%;
    border: 1px solid #ffffff;
    box-sizing: border-box;
    border-radius: 6px;
  }
}

.swiper-container {
  margin: 16px 16px 0;

  .swiper-wrapper {
    margin-bottom: 28px;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    width: 100%;
    height: auto;
  }

  .swiper-pagination {
    bottom: 11px;

    .swiper-pagination-bullet {
      background: rgba(255, 255, 255, 0.6);

      &-active {
        background: rgba(255, 255, 255, 0.9);
      }
    }
  }
}
</style>
